import { useEffect, useState } from "react";
import useMyBtStore from "@features/mybt/store/useMyBTStore";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { FeedTag } from "@routes/Keyword/utils/types";

export const useMyBtKeywords = () => {
  const [tags, setTags] = useState<FeedTag[]>([]);
  const { isAnonymous, visitorId } = useUserInfo();
  const userTags = useMyBtStore((store) => store.tags);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (isAnonymous) return;
    if (!visitorId) return;

    setTags(userTags);
  }, [isAnonymous, visitorId, userTags]);

  return { tags };
};
